module.exports = __webpack_public_path__ + "static/media/heart-circle.632fe613.svg";